import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProductRegistryPage } from '../../../../features/products/pages/ProductRegistryPage';
import { getSession } from '../../../../lib/session';
import { usePageTitle } from '../../../../lib/hooks';

function AdminProductsRoute() {
  usePageTitle('Products');
  return <ProductRegistryPage />;
}

export const Route = createFileRoute('/_auth/admin/products/')({
  beforeLoad: ({ location }) => {
    const session = getSession();
    // Gate to Platform Admin (group_admin or users with specific permission)
    const isPlatformAdmin = 
      session?.user.type === 'group_admin' || 
      session?.user.type === 'company_admin' || 
      session?.permissions.includes('admin.products.read');

    if (!isPlatformAdmin) {
      throw redirect({
        to: '/',
        search: {
          callbackUrl: location.href,
        },
      });
    }
  },
  component: AdminProductsRoute,
});
